import { Stack, Box, Typography, Chip } from "@mui/material"
import { useParams } from "react-router-dom"
import { endpoint } from "../../config"
import { useSelector } from 'react-redux'
import { useEffect, useState } from "react"
import './index.css'
import { FiberManualRecord, ThumbDown, ThumbUp } from "@mui/icons-material"
import VideoGrid from "../Home/VideoGrid"
import axios from 'axios'
import CircularProgressBox from "../CircularProgressBox"

export default function VideoPage(props) {
    const videos = useSelector(state => state.videos)
    
    let { id } = useParams()
    
    const video = videos.filter(video => video._id == id)[0]
    // console.log(video)

    const [upVotes, setUpVotes] = useState(video?.votes?.upVotes || 0)
    const [downVotes, setDownVotes] = useState(video?.votes?.downVotes || 0)
    const [toggleUpVote, setToggleUpVote] = useState(false)
    const [toggleDownVote, setToggleDownVote] = useState(false)
    
    if(!videos.length) return <CircularProgressBox/>

    if(!video) return <Typography>Video Not Found</Typography>


    const handleUpVote = async () => {
        setUpVotes(toggleUpVote ? upVotes - 1 : upVotes + 1)
        setToggleUpVote(!toggleUpVote)

        const patchUpVote = {
            "vote": "upVote",
            "change": toggleUpVote ? "increase" : "decrease"
        }
        const res = await axios.patch(`${endpoint}/${id}/votes`, patchUpVote)
    }
    const handleDownVote = async () => {
        setDownVotes(toggleDownVote ? downVotes - 1 : downVotes + 1)
        setToggleDownVote(!toggleDownVote)

        const patchDownVote = {
            "vote": "downVote",
            "change": toggleDownVote ? "increase" : "decrease"
        }
        const res = await axios.patch(`${endpoint}/${id}/votes`, patchDownVote)
    }


    return (
        <div className="video-page">
            <Stack className="iframe-parent">
                <Stack 
                    justifyContent='space-between'
                    sx={{
                        height: '100%'
                    }}
                >
                    <iframe id='video-iframe' title={video.title} src={'https://' + video.videoLink} allowFullScreen />
                    <Stack 
                        direction='row' 
                        justifyContent='space-between'
                        alignItems='center'
                        flexWrap='wrap'
                        sx={{
                            padding: '1rem',
                            margin: '0.5rem'
                        }}
                    >
                        <Stack alignItems='start'>
                            <Typography variant="h4" color='white'>
                                {video.title}
                            </Typography>
                            <Stack direction='row' justifyContent='space-around'>
                            <Typography variant='subtitle2' color='white'>
                                {video.contentRating}
                            </Typography>
                            |
                            <Typography variant="subtitle2" color='white'>
                                {video.releaseDate}
                            </Typography>
                            </Stack>
                        </Stack>
                        <Stack direction='row' justifyContent='space-around' alignItems='start' sx={{margin: "1rem 0 oyauto"}}>
                            <Chip 
                                label={upVotes} 
                                icon={<ThumbUp/>} 
                                color={toggleUpVote ? "secondary" : "primary"}
                                sx={{marginRight: '1rem', padding: '0.75rem', width: '100%'}}
                                onClick={() => handleUpVote()}
                            />
                            <Chip 
                                label={downVotes} 
                                icon={<ThumbDown/>} 
                                color={toggleDownVote ? "secondary" : "primary"} 
                                sx={{marginRight: '1rem', padding: '0.75rem', width: '100%'}}
                                onClick={() => handleDownVote()}
                            />
                        </Stack>
                    </Stack>
                </Stack>
                <hr id="devider-rule"/>
                <VideoGrid/>
            </Stack>
        </div>
    )
}